export default "/images/vendor/flag-icon-css/flags/1x1/bd.svg?a62e330d249ff3f5bd27978a78c3d1d6";